import { useState } from 'react'
import ItemTabs from 'components/ItemTabs'
import ColumnChart from 'components/Charts/ColumnChart'
import PieChart from 'components/Charts/PieChart'
import DreService from 'services/Dre'
import { MONTH_HEADER_LABELS, formatPercentage } from './utils'

import {
  ChartContainer,
  Section,
  SectionTitle,
  EmptyText,
  CardsRow,
  Card,
  CardLabel,
  CardMoney,
  CardHint
} from './styles'

const MODE_TABS = [
  { label: 'Mensal', value: 'monthly' },
  { label: 'Anual', value: 'yearly' }
]

// Os gráficos de coluna do web são empilhados por padrão; aqui as séries se comparam
// lado a lado (Receita Total x Líquida, Líquida x Lucro), então desempilha.
const SIDE_BY_SIDE = { isStacked: false }

export default function DreChart({ statement, year }) {
  const [mode, setMode] = useState('monthly')
  const {
    monthlyComposition,
    monthlyRevenue,
    monthlyProfit,
    yearComposition,
    summary,
    hasRevenue
  } = DreService.buildChartData(statement, MONTH_HEADER_LABELS)

  if (!hasRevenue) {
    return <EmptyText>Nenhuma receita registrada em {year}.</EmptyText>
  }

  return (
    <ChartContainer>
      <ItemTabs
        tabs={MODE_TABS}
        selectedTab={mode}
        tabWidth={120}
        onTabChange={setMode}
        containerStyle={{padding: 0}}
      />
      {mode === 'monthly' ? (
        <>
          <Section>
            <SectionTitle>Composição da receita</SectionTitle>
            <ColumnChart data={monthlyComposition}/>
          </Section>
          <Section>
            <SectionTitle>Receita Total x Receita Líquida</SectionTitle>
            <ColumnChart data={monthlyRevenue} options={SIDE_BY_SIDE}/>
          </Section>
          <Section>
            <SectionTitle>Receita Líquida x Lucro Líquido</SectionTitle>
            <ColumnChart data={monthlyProfit} options={SIDE_BY_SIDE}/>
          </Section>
        </>
      ) : (
        <>
          <CardsRow>
            <Card>
              <CardLabel>Receita Total</CardLabel>
              <CardMoney value={summary.revenueTotal}/>
            </Card>
            <Card>
              <CardLabel>Descontos</CardLabel>
              <CardMoney value={summary.discounts} tone='#FF3939'/>
              <CardHint>{formatPercentage(summary.discountPercentage)} da receita total</CardHint>
            </Card>
            <Card>
              <CardLabel>Receita Líquida</CardLabel>
              <CardMoney value={summary.netRevenue} tone='#44CF6C'/>
            </Card>
          </CardsRow>
          <CardsRow>
            <Card>
              <CardLabel>Despesas totais</CardLabel>
              <CardMoney value={summary.expenses} tone='#FF3939'/>
            </Card>
            <Card>
              <CardLabel>Impostos</CardLabel>
              <CardMoney value={summary.taxes} tone='#FF3939'/>
            </Card>
            <Card>
              <CardLabel>Lucro Líquido</CardLabel>
              <CardMoney value={summary.netProfit} tone={summary.netProfit >= 0 ? '#44CF6C' : '#FF3939'}/>
            </Card>
          </CardsRow>
          <Section>
            <SectionTitle>Composição da receita do ano</SectionTitle>
            <PieChart data={yearComposition}/>
          </Section>
        </>
      )}
    </ChartContainer>
  )
}
